
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Versicherung from '@/types/Versicherung';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { DeleteVersicherungPayload, UpdateVersicherungPayload, VersicherungenFilter } from '@/store/versicherungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('versicherungen', ['loaders']),
        },
        methods: {
            ...mapActions('versicherungen', ['loadVersicherungen', 'updateVersicherung', 'deleteVersicherung']),
        },
    })
    export default class VersicherungenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() versicherung!: Versicherung;
        @Prop() filter!: VersicherungenFilter;

        public $refs!: {
            form: VForm;
        };

        public updateVersicherung!: (payload: UpdateVersicherungPayload) => void;
        public deleteVersicherung!: (payload: DeleteVersicherungPayload) => void;

        public get isEdit(): boolean {
            return this.versicherung.versicherung_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateVersicherung({ versicherung: this.versicherung, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Versicherung endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteVersicherung({ versicherung: this.versicherung, filter: this.filter });
                    }
                });
        }
    }
